import apiClient from './client';

export const getMyClasses = async () => {
  const response = await apiClient.get('/api/classes/mine');
  return response.data;
};

export const createClass = async (name, deckCode = null) => {
  const body = { name };
  if (deckCode) body.deck_code = deckCode;
  const response = await apiClient.post('/api/classes/create', body);
  return response.data;
};

export const joinClass = async (joinCode) => {
  const response = await apiClient.post('/api/classes/join', { join_code: joinCode });
  return response.data;
};

export const leaveClass = async (classId) => {
  const response = await apiClient.delete(`/api/classes/${classId}/leave`);
  return response.data;
};

export const getClassDetails = async (classId) => {
  const response = await apiClient.get(`/api/classes/${classId}`);
  return response.data;
};

export const getClassLeaderboard = async (classId, type = 'learn') => {
  const response = await apiClient.get(`/api/classes/${classId}/leaderboard?type=${type}`);
  return response.data;
};

export const updateClassVisibility = async (classId, showName) => {
  const response = await apiClient.patch(`/api/classes/${classId}/visibility`, { show_name: showName });
  return response.data;
};

export const getClassSuggestions = async () => {
  const response = await apiClient.get('/api/classes/suggestions');
  return response.data;
};

export const acceptClassSuggestion = async (classId) => {
  const response = await apiClient.post(`/api/classes/suggestions/${classId}/accept`);
  return response.data;
};

export const getClassmateDecks = async (classId) => {
  const response = await apiClient.get(`/api/classes/${classId}/classmate-decks`);
  return response.data;
};

export const claimClassmateDeck = async (classId, deckId) => {
  const response = await apiClient.post(`/api/classes/${classId}/claim-deck/${deckId}`);
  return response.data;
};
